
// 导入封装好的请求
import request from '@/utils/request'

/**
 * 查询面试题指定内容
 */
export const findBankContent=(bankId)=>{
    return request.get(
        '/questionBand/findBankContent',
        {
            params:{
                bankId:bankId
            }
        }
    )

}
